import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { HTTPService } from "./../../../services/httpService";
import { getDisplayDates } from "../../../util/dateDisplayUtils";
// Remove the calculation imports - we'll use stored values
// import { calculateFinalAmount, formatCurrency } from './../services/serviceUtils';

import moment from "moment";
import _ from "lodash";

const API = new HTTPService();

export class ViewJob extends Component {
  // Utility function for currency formatting (no calculations)
  formatCurrency = (amount) => {
    return `$${parseFloat(amount || 0).toFixed(2)}`;
  };

  // Fetch Signed URL when the button is clicked (for contract)
  fetchSignedUrl = async () => {
    const newTab = window.open("", "_blank"); // open the tab
    try {
      const response = await API.get(
        `signedURL/?requestId=${this.props.request.requestId}`
      );
      if (response.data.signedUrl) {
        newTab.location.href = response.data.signedUrl; // populate the link
      } else {
        console.error("No signed URL found.");
      }
    } catch (error) {
      console.error("Error fetching signed URL:", error);
      alert("Error accessing contract.");
    }
  };

  // Fetch Estimate PDF URL
  fetchEstimatePdf = async () => {
    try {
      const response = await API.get(`/requests/${this.props.request.requestId}/quote-pdf`);
      if (response.data.url) {
        window.open(response.data.url, '_blank');
      } else {
        alert('PDF not available at this time.');
      }
    } catch (error) {
      console.error('Error downloading estimate PDF:', error);
      alert('PDF not available at this time.');
    }
  };

  render() {
    let vehicle =
      this.props.request.vehicleYear +
      " " +
      this.props.request.vehicleMake +
      " " +
      this.props.request.vehicleModel +
      " ";

    // Use stored database values - no frontend calculations
    const requestTotal = parseFloat(this.props.request.requestTotal || 0);
    const requestDiscount = parseFloat(this.props.request.requestDiscount || 0);
    const requestTaxes = parseFloat(this.props.request.requestTaxes || 0);
    
    // Customer pays: final amount + taxes (only calculation allowed)
    const finalAmount = requestTotal - requestDiscount;
    const customerTotal = finalAmount + requestTaxes;
    
    let totalCost = this.formatCurrency(customerTotal);
    let totalTax = this.formatCurrency(requestTaxes);
    
    // Use getDisplayDates utility for correct scheduled dates
    const displayDates = getDisplayDates(
      this.props.request,
      this.props.calendarDays || [],
      this.props.userType
    );
    let startDate = moment(displayDates.startDate).format("ddd, MMM Do YYYY");
    let endDate = moment(displayDates.endDate).format("ddd, MMM Do YYYY");
    const startLabel = displayDates.startLabel || "Work Starts";
    const endLabel = displayDates.endLabel || "Work scheduled to complete";

    var noteText = "None";
    if (this.props.notes.length > 0) {
      if (this.props.notes[0].note_text.length > 1)
        noteText = this.props.notes[0].note_text;
    }

    const services = this.props.services;
    const columns = [
      {
        dataField: "category",
        text: "Category",
      },
      {
        dataField: "desc",
        text: "Service",
      },
      {
        dataField: "amount",
        text: "Amount",
      },
      {
        dataField: "duration",
        text: "Duration",
      },
    ];

    let services_ = [];
    for (let i = 0; i < services.length; i++) {
      // Use stored service_value (final amount after discount) from database
      // If service_value doesn't exist, fall back to calculation for backward compatibility
      let displayAmount;
      if (services[i].service_amount !== undefined && services[i].service_amount !== null) {
        // Use stored calculated value (preferred)
        const serviceAmount = parseFloat(services[i].service_amount || 0);
        const serviceDiscount = parseFloat(services[i].service_discount || 0);
        displayAmount = this.formatCurrency(serviceAmount - serviceDiscount);
      } else {
        // Fallback calculation for older records that might not have service_value
        const serviceAmount = parseFloat(services[i].service_amount || 0);
        const serviceDiscount = parseFloat(services[i].service_discount || 0);
        displayAmount = this.formatCurrency(serviceAmount - serviceDiscount);
      }

      let rowView = {
        serviceId: services[i].service_id,
        category: services[i].service_category,
        desc: services[i].custom_description,
        amount: displayAmount,
        duration: services[i].service_duration
      };

      services_.push(rowView);
    }

    // Determine which invoice number to display
    const invoiceDisplay = this.props.request.customer_facing_invoice 
      ? this.props.request.customer_facing_invoice 
      : this.props.request.invoiceId;

    return(
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Work Detail for {this.props.request.dealerName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col">
              <h6>Email: {this.props.request.email}</h6>
            </div>
            <div className="col">
              <h6>Phone: {this.props.request.phone_number}</h6>
            </div>
          </div>
          <hr></hr>
          <div className="row">
            <div className="col text-center">
              <h5>{vehicle}</h5>
            </div>
            {(!this.props.request.vin || this.props.request.vin.substring(0, 2) !== "NV") && (
              <div className="col text-center">
                <h5>VIN : {this.props.request.vin || "N/A"}</h5>
              </div>
            )}
          </div>
          <hr></hr>
          <div className="row">
            <div className="col">
              <h6>{startLabel} : {startDate}</h6>
            </div>
            <div className="col">
              <h6>{endLabel} : {endDate}</h6>
            </div>
          </div>
          <hr></hr>
          
          {/* Enhanced pricing display with stored values */}
          {this.props.request.requestType === "installer" && (
            <div>
              <div className="row">
                <div className="col text-center">
                  <h5>Total Cost : {totalCost} including taxes of {totalTax}</h5>
                </div>
              </div>
              {requestDiscount > 0 && (
                <div className="row">
                  <div className="col text-center">
                    <small className="text-muted">
                      Original: {this.formatCurrency(requestTotal)} - 
                      Discount: {this.formatCurrency(requestDiscount)} = 
                      Subtotal: {this.formatCurrency(finalAmount)}
                    </small>
                  </div>
                </div>
              )}
            </div>
          )}
          
          {this.props.request.requestType === "dealer" && (
            <div>
              <div className="row">
                <div className="col text-center">
                  <h5>Total Cost : {this.formatCurrency(finalAmount)}</h5>
                </div>
              </div>
              {requestDiscount > 0 && (
                <div className="row">
                  <div className="col text-center">
                    <small className="text-muted">
                      Original: {this.formatCurrency(requestTotal)} - 
                      Discount: {this.formatCurrency(requestDiscount)}
                    </small>
                  </div>
                </div>
              )}
            </div>
          )}

          {noteText !== "None" && (
            <div>
              <hr></hr>
              <div className="row">
                <div className="col">
                  <p>Work Notes : {this.props.notes[0].note_text}</p>
                </div>
              </div>
            </div>
          )}
          <hr></hr>
          <h5>Itemized Costs</h5>
          <BootstrapTable
            keyField="serviceId"
            data={services_}
            columns={columns}
          />
          
          {/* Show breakdown of stored values for transparency */}
          <div className="row mt-3">
            <div className="col-12">
              <small className="text-muted">
                <div>Original Total: {this.formatCurrency(requestTotal)}</div>
                {requestDiscount > 0 && (
                  <div>Total Discount: {this.formatCurrency(requestDiscount)}</div>
                )}
                <div>Subtotal: {this.formatCurrency(finalAmount)}</div>
                {requestTaxes > 0 && (
                  <div>Taxes: {this.formatCurrency(requestTaxes)}</div>
                )}
                <div><strong>Customer Pays: {totalCost}</strong></div>
              </small>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <p>Request # {this.props.request.requestId}</p>
            </div>
            <div className="col">
              <p>Invoice # {invoiceDisplay}</p>
            </div>
            <div className="col">
              <p>
                Current State : {_.capitalize(this.props.request.currentState)}
              </p>
            </div>
          </div>

          {/* State History */}
          {this.props.history && this.props.history.length > 0 && (
            <div className="row mt-3">
              <div className="col-12">
                <h6>State History</h6>
                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  <table className="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Changed By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.history.map((state, index) => (
                        <tr key={index}>
                          <td>{moment(state.stateDate).format("MMM D, YYYY h:mm A")}</td>
                          <td>{_.capitalize(state.requestStatus)}</td>
                          <td>{state.changedByUserEmail || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col">
              {this.props.request.contract_url && (
                <button
                  type="button"
                  onClick={this.fetchSignedUrl}
                  className="button btn-secondary m-2 buttons"
                >
                  CUSTOMER CONTRACT
                </button>
              )}
              {(this.props.request.quoteSentAt || this.props.request.quote_sent_at) && (
                <button
                  type="button"
                  onClick={this.fetchEstimatePdf}
                  className="button btn-secondary m-2 buttons"
                >
                  ESTIMATE PDF
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}